// extracted by mini-css-extract-plugin
export var askAiIcon = "_k2-9";
export var container = "_k2-0";
export var groupSeparator = "_k2-a";
export var highlight = "_k2-4";
export var resultIcon = "_k2-5";
export var resultItem = "_k2-7";
export var resultSubtitle = "_k2-3";
export var resultTitle = "_k2-2";
export var resultsList = "_k2-1";
export var searchGroup = "_k2-6";
export var selected = "_k2-8";